import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchTransferDetails } from '../../../../../../../../jsx/actions/transferAction';
import { TableLayout } from '../../containers/Layout';
import { TableRow, TableCell, Typography, TableHead, TableBody, TableFooter } from '@material-ui/core';
import SingleBL from '../../reapproIntern/SingleBL';
import Currency from '../../../../../commonModules/Currency';
import SingleTransferTemplate from '../singleTemplates/SingleTransferTemplate';
import { isEmpty } from 'lodash-es';
import { fetchShopDetails } from '../../../../../../../../jsx/actions/shopAction';

const SingleTransferReapproExt = (props) => {
    const dispatch = useDispatch();
	const PRODUCTS = useSelector((state) => state.inventory.products); 
    
    const [trsf, setTrsf] = useState({});
    const [BL, setBL] = useState(false);
    const [shopDest, setShopDest] = useState({});

    useEffect(() => {
        const fetchTransferData = async () => {
            try {
                const data = await dispatch(fetchTransferDetails(props.transfer.id));
                const shopDEST = await dispatch(fetchShopDetails(props.transfer.shop_dest));
                console.log('=================DATA===================');
                console.log({data, DEST: props.transfer.shop_dest});
                console.log('====================================');
                setTrsf(data);
                setShopDest(shopDEST);
            } catch (error) {
                console.error('Error fetching transfer details:', error);
            }
        };
    
        fetchTransferData();
        // fetchLocals();
        // Fetch dest shop
        // Example:
        // const fetchDestShop = async () => {
        //     const response = await fetch(`/api/shops/${props.trsf.shopDestId}`);
        //     const data = await response.json();
        //     setShopDest(data);
        // };
        // fetchDestShop();
    }, [dispatch, props.transfer.shopDest, props.transfer.id]);

    const createProductList = () => {

        return trsf.products.map((reapproItem) => {
            let prod = PRODUCTS && PRODUCTS[reapproItem.product_id];
            const ssTtBeforeMargin = parseFloat(reapproItem.total_ht); // prix vendu
            const margin = trsf.price_margin
                ? parseFloat(reapproItem.total_ht * (trsf.price_margin / 100))
                : 0; // montant marge

            let PU = ssTtBeforeMargin / reapproItem.quantity;

            return (
                <TableRow key={reapproItem.product_id}>
                    <TableCell className="photo-trsf-single">
                        {prod && prod.photos && prod.photos.length > 0 && prod.photos[0].filename &&
                            <img 
                                id={prod.photos[0].filename} 
                                src={`/stocks/photos/${prod.photos[0].filename}`} 
                                // style={{width:"100px", height:"auto"}}
                            />
                        }
                    </TableCell>
                    <TableCell className="text-left">{prod?.name || `Product ID: ${reapproItem.product_id}`}</TableCell>
                    <TableCell>{reapproItem.quantity}</TableCell>
                    <TableCell>
                        <Currency value={PU} />
                    </TableCell>
                    <TableCell>
                        <Currency value={ssTtBeforeMargin} />
                    </TableCell>
                    <TableCell>{trsf.price_margin || 0} %</TableCell>
                    <TableCell>
                        <Currency value={margin} />
                    </TableCell>
                    <TableCell>
                        <Currency value={reapproItem.total_ttc} />
                    </TableCell>
                </TableRow>
            );
        });
    };

    const getTotal = () => {
        let total = 0;
        let totalBase = 0;

        trsf.products.forEach((reapproItem) => {
            const ssTt = parseFloat(reapproItem.total_ht); // prix vendu
            const ssTtBeforeMargin = trsf.price_margin
                ? parseFloat(reapproItem.total_ht / (1 + trsf.price_margin / 100))
                : ssTt; // prix vendu avant marge

            total += ssTt || 0;
            totalBase += ssTtBeforeMargin || 0;
        });

        return [
            <Currency value={total} />,
            <Currency value={totalBase} />,
        ];
    };

    return (
        <SingleTransferTemplate
            shop={props.shop}
            shopDest={shopDest}
            transfer={trsf}
            notif={props.notif}
            handleBL={() => setBL(!BL)}
            BL={BL}
            BLOpt
        >
            {BL ? (
                <SingleBL  transfer={trsf} PRODUCTS={PRODUCTS} />
            ) : (
                <>
                {!isEmpty(trsf) &&
                    <TableLayout>
                        <TableHead>
                            <TableRow>
                                <TableCell ></TableCell>
                                <TableCell className="text-left">Produit</TableCell>
                                <TableCell>Quantité</TableCell>
                                <TableCell>PU HT</TableCell>
                                <TableCell>Total HT</TableCell>
                                <TableCell colSpan={2}>Marge</TableCell>
                                <TableCell>Total TTC</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>{createProductList()}</TableBody>
                        <TableFooter>
                            <TableRow>
                                <TableCell colSpan={4} style={{ textAlign: 'right' }}>
                                    Sous Total
                                </TableCell>
                                <TableCell>{getTotal()[1]}</TableCell>
                                <TableCell colSpan={2}>
                                    <Currency value={trsf.price_margin ? trsf.price_ht * (trsf.price_margin / 100) : 0} />
                                </TableCell>
                                <TableCell className="f-700">{getTotal()[0]}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell colSpan={7} style={{ textAlign: 'right' }}>
                                    Transport
                                </TableCell>
                                <TableCell>
                                    <Currency value={trsf.transport || 0} />
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell colSpan={7} style={{ textAlign: 'right' }}>
                                    Autres Taxes
                                </TableCell>
                                <TableCell>
                                    <Currency value={trsf.taxes || 0} />
                                </TableCell>
                            </TableRow>
                            <TableRow style={{ backgroundColor: '#f5f5f5' }}>
                                <TableCell colSpan={7} style={{ textAlign: 'right', fontWeight: 700 }}>
                                    TOTAL (Prix de revient)
                                </TableCell>
                                <TableCell style={{ fontWeight: 700 }}>
                                    <Currency value={trsf.prix_revient || ((trsf.total_price_TTC || trsf.total_price || 0) + (trsf.transport || 0) + (trsf.taxes || 0))} />
                                </TableCell>
                            </TableRow>
                        </TableFooter>
                    </TableLayout>
                }
                </>
            )}
        </SingleTransferTemplate>
    );
};

export default SingleTransferReapproExt;
